import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import { matchPath, useLocation } from "react-router-dom";

import Button from "@components/atoms/Button";
import Icon from "@components/atoms/Icon";
import NavMenu from "@components/molecules/NavMenu";
import NavMenuItem from "@components/molecules/NavMenu/NavMenuItem";
import Detail from "@components/organisms/Footer/Detail";
import FooterLogo from "@components/organisms/Footer/FooterLogo";

import useLayout from "@hooks/reducerHooks/useLayout";
import useUser from "@hooks/reducerHooks/useUser";

import { URLS } from "@const/urls";

interface IProps {
  headerFoot?: boolean;
}

function Footer({ headerFoot = false }: IProps) {
  const location = useLocation();
  const { openLoginModal, closeHeader } = useLayout();
  const { accessToken } = useUser();
  const { t } = useTranslation();
  const currentPathname = location.pathname;

  return (
    <footer
      className={classNames(
        headerFoot
          ? "flex flex-col justify-between"
          : [
              "pc:col-span-12 col-span-6 px-4 pt-20 pb-5",
              !currentPathname.includes(URLS.COLLECTIONS) &&
                currentPathname !== URLS.DRAW &&
                currentPathname !== URLS.FEATURES &&
                currentPathname !== URLS.SEARCH &&
                "pc:px-5 px-4",
            ],
      )}
    >
      <div className="pc:mb-0 pc:grid-cols-4 pc:gap-5 mb-10 grid grid-cols-2 gap-x-2.5 gap-y-5">
        {headerFoot ? (
          <NavMenu className="order-1 w-fit basis-1/2" title="Account">
            {accessToken ? (
              <>
                <NavMenuItem goToUrl={URLS.ACCOUNT_ORDER_HISTORY} name={t("footer.headerFoot.order_history")} />
                <NavMenuItem
                  goToUrl={URLS.ACCOUNT_PERSONAL_INFORMATION}
                  name={t("footer.headerFoot.personal_information")}
                />
              </>
            ) : (
              <li className="w-fit">
                <Button
                  onClick={() => {
                    closeHeader();
                    openLoginModal({ redirectUrl: location.pathname });
                  }}
                  styleType="secondary"
                  variant="contained"
                >
                  {t("footer.headerFoot.login_and_register_button")}
                </Button>
              </li>
            )}
          </NavMenu>
        ) : null}
        <FooterLogo />

        {/*CUSTOMER CARE*/}
        <NavMenu className={classNames(headerFoot && "order-3 basis-1/2")} title="Customer Care">
          <NavMenuItem goToUrl={URLS.PAGES_CS} name={t("footer.nav.cs")} />
          <NavMenuItem goToUrl={URLS.PAGES_SHIPPING_INFORMATION} name={t("footer.nav.shipping")} />
        </NavMenu>

        {/*TERMS*/}
        <NavMenu className={classNames(headerFoot && "order-4 basis-1/2")} title="Terms">
          <NavMenuItem goToUrl={URLS.PAGES_PRIVACY_POLICY} name={t("footer.nav.privacy_policy")} />
          <NavMenuItem goToUrl={URLS.PAGES_TERMS_AND_CONDITIONS} name={t("footer.nav.terms_condition")} />
        </NavMenu>
      </div>
      {!headerFoot ? <Detail /> : <span className="mt-10 block text-xs">COPYRIGHT © 2023. ALL RIGHTS RESERVED.</span>}
    </footer>
  );
}

export default Footer;
